exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-count[data-v-29d25298] {\n  background-color: #edeced;\n  color: #8f8f8f;\n  border: solid 1px #8f8f8f;\n}\n.group-active[data-v-29d25298] {\n  background-color: white !important;\n  color: black !important;\n  box-shadow: inset 0 -3px 0 #ac3f5d;\n}\n.group-description[data-v-29d25298] {\n  font-size: 60%;\n}\n@media screen and (min-width: 768px) {\n.group-description[data-v-29d25298] {\n    font-size: 80%;\n}\n}", ""]);

// exports
